import Decimal from 'decimal.js';

import { types as sdkTypes } from '../util/sdkLoader';

const { Money } = sdkTypes;

const useLineItemsTotal = (lineItems, unitTypes, onlyReversal, marketplaceCurrency) => {
  const [{ lineTotal: { currency = marketplaceCurrency } = {} } = {}] = lineItems || [];

  if (!currency) {
    return null;
  }

  const linesTotal = lineItems.reduce((total, { code, lineTotal: { amount } = {}, reversal }) => {
    if (!amount) {
      return total;
    }

    if (unitTypes && unitTypes.indexOf(code) === -1) {
      return total;
    }

    if (typeof onlyReversal === 'boolean' && onlyReversal !== reversal) {
      return total;
    }

    return total.add(amount);
  }, new Decimal(0));

  return new Money(linesTotal.toNumber(), currency);
};

export default useLineItemsTotal;
